// ============================================================================
// RAID CARD SECTION
//
// The badge-plus-inline-list pair for card layouts (NFRs, features, ADRs).
// StoryRow composes the same two components directly because it lives inside a
// table cell with its own spacing; everywhere else uses this wrapper so the
// three card surfaces cannot drift apart.
// ============================================================================

import React from 'react';
import { RaidItem, RaidStatus } from '../../../types/raid';
import { RaidBadge } from './RaidBadge';
import { RaidInlineList } from './RaidInlineList';

export interface RaidCardControls {
  items: RaidItem[];
  openCount: number;
  blockingCount: number;
  isExpanded: boolean;
  onToggle: () => void;
  onAdd: () => void;
  onEditItem: (item: RaidItem) => void;
  onResolveItem: (raidId: string, status: RaidStatus, resolution: string) => void;
  saving?: boolean;
}

export function RaidCardSection({ controls }: Readonly<{ controls?: RaidCardControls }>) {
  if (!controls) return null;
  return (
    <>
      <RaidBadge
        count={controls.items.length}
        openCount={controls.openCount}
        blockingCount={controls.blockingCount}
        isExpanded={controls.isExpanded}
        onToggle={controls.onToggle}
        onAdd={controls.onAdd}
      />
      {controls.isExpanded && controls.items.length > 0 && (
        <RaidInlineList
          items={controls.items}
          saving={controls.saving}
          onResolve={controls.onResolveItem}
          onEdit={controls.onEditItem}
          onAdd={controls.onAdd}
        />
      )}
    </>
  );
}
